import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {ServiceStatusService} from '../../services/service-status/service-status.service';

export const maintenanceRouteGuard: CanActivateFn = async () => {
  const serviceStatusService = inject(ServiceStatusService);
  const router = inject(Router);

  const inMaintenance = await serviceStatusService.isInMaintenance();
  if (inMaintenance) {
    return router.parseUrl('/maintenance');
  }
  return true;
};
